import React from 'react';
import ReactDOM from 'react-dom/client';
import SearchableSearchField from "./searchable-search-field.jsx";
import {__, _nonce} from '../../../../assets/javascripts/library.js';
import Modal from '../../global-components/modal.jsx';
import { useState } from 'react';
import {ToasterProvider, useToaster} from "../../global-components/toaster.jsx";
import {updatePartialPayment} from "../../../../assets/javascripts/update-payment.jsx"
import {do_resignon, do_signoff} from "../../../../assets/javascripts/update-registration-status.jsx";
import Overview from "../partials/overview.jsx";
import AllParticipants from "../partials/all-participants.jsx";
import LocalGroupParticipants from "../partials/localgroup-participants.jsx";
import ParticipationGroupParticipants from "../partials/participationgroup-participants.jsx";
import SignedOffParticipants from "../partials/signedoff-participants.jsx";
import Settings from "../partials/settings.jsx";
import MailComposer from "../../mailclient/mail-composer.jsx";
import EditParticipant from "../partials/edit-participant.jsx";

function SearchableParticipantList({link, table_id, today, group_data, event_data}) {
    const { showToast } = useToaster();
    const [showModalPayment, setShowModalPayment] = useState(false);
    const [showModalSignoff, setShowModalSignoff] = useState(false);
    const [selectedParticipant, setSelectedParticipant] = useState(null);

    const solea_edit_participant = (participant_id) => {
        const response = fetch("/wp-json/solea/event-details/print-page/edit-participant", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                participant_id: participant_id,
                solea_nonce: _nonce(),
            }),
        })
            .then((res) => res.json())
            .then((data) => {

                    var container = document.getElementById('solea_event_group_contents');
                    var root = ReactDOM.createRoot(container);
                    root.render(
                        <ToasterProvider>
                            <EditParticipant event={data.event} participant={data.participant} link={link} />
                        </ToasterProvider>
                    );
                }
            );
    }

    const solea_send_group_mail = (event_id, internal_group_name, addon_id) => {
        const response = fetch("/wp-json/solea/mail-client/open-composer", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                mode: 'group',
                group_name: internal_group_name,
                event_id: event_id,
                addon_id: addon_id,
                solea_nonce: _nonce(),
            }),
        })
            .then((res) => res.json())
            .then((data) => {

                    var container = document.getElementById('solea_event_group_contents');
                    var root = ReactDOM.createRoot(container);
                    root.render(
                        <ToasterProvider>
                            <MailComposer event_id={data.event_id} recipients={data.recipients} comes_from={link} />
                        </ToasterProvider>
                    );
                }
            );
    }


    const send_single_mail = (event_id, user_id) => {
        const response = fetch("/wp-json/solea/mail-client/open-composer", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                mode: 'single',
                user_id: user_id,
                event_id: event_id,
                solea_nonce: _nonce(),
            }),
        })
            .then((res) => res.json())
            .then((data) => {

                    var container = document.getElementById('solea_event_group_contents');
                    var root = ReactDOM.createRoot(container);
                    root.render(
                        <ToasterProvider>
                            <MailComposer event_id={data.event_id} recipients={data.recipients} comes_from={link} />
                        </ToasterProvider>
                    );
                }
            );
    }
    console.log(group_data);

    return (
        <fieldset>
            <legend>
                <h3>
                    {group_data.name} ( {group_data.participants.length } {__( 'Participants', 'solea' )} )
                </h3>
            </legend>

            <SearchableSearchField searchable_table_id={table_id} />
            <table className="wp-list-table widefat fixed striped table-view-list solea_participant_group" id={table_id}>
                <thead>
                <tr>
                    <th className="manage-column column-name" scope="col">{ __( 'Name', 'solea' ) }</th>
                    <th className="manage-column column-name">{ __( 'Presence days', 'solea' ) }</th>
                    <th className="manage-column column-name">{ __( 'Local group', 'solea' ) }</th>
                    <th className="manage-column column-name">{ __( 'Amount', 'solea' ) }</th>
                    <th className="manage-column column-name">{ __( 'E-mail address', 'solea' ) }</th>
                    <th className="manage-column column-name">{ __( 'Telephone', 'solea' ) }</th>
                    <th className="manage-column column-name">{ __( 'Actions', 'solea' ) }</th>
                </tr>
                </thead>
                <tbody>
                {(group_data.participants.map((participant, index) => (
                    <tr id={"participant_row_" + participant.id}>
                        <td>
                            {participant.nickname !== '' && participant.nickname !== null && (
                                <label>{participant.nickname}<br />(</label>
                            )}
                            {participant.fullname}
                            {participant.nickname !== '' && participant.nickname !== null && (
                                <label>)</label>
                            )}
                        </td>
                        <td>
                            { __('On', 'solea')}: {participant.arrival}<br />
                            { __('Dep', 'solea')}: {participant.departure}
                        </td>
                        <td>{participant.local_group_string}</td>

                        {participant.amount !== participant.amount_paid && (
                            <td
                                id={"payment_participant_" + participant.id}
                                className="red red-background">
                                {participant.amount_string}
                                {null != participant.date_unregister ? (
                                    <label>
                                        <br />{__( 'Signed off', 'solea' )}: {participant.date_unregister_formatted}
                                    </label>
                                ) : (<label>
                                        <br />{__( 'Registered', 'solea' )}: {participant.date_register_formatted}
                                    </label>
                                ) }
                            </td>
                        ) }

                        {participant.amount === participant.amount_paid && (
                            <td id={"payment_participant_" + participant.id}>
                                {participant.amount_string}
                                {null != participant.date_unregister ? (
                                    <label>
                                        <br />{__( 'Signed off', 'solea' )}: {participant.date_unregister_formatted}
                                    </label>
                                ) : (
                                    <label>
                                    <br />{__( 'Registered', 'solea' )}: {participant.date_register_formatted}
                            </label>
                                    )}
                            </td>
                        ) }

                        <td>
                            {participant.email_1}
                            {
                                participant.email_2 !== '' &&
                                participant.email_2 !== null &&
                                participant.email_2 !== participant.email_1
                                && (<label><br />{participant.email_2}</label>)
                            }
                        </td>
                        <td>
                            {participant.telefon_1}
                            {
                                participant.telefon_2 !== '' &&
                                participant.telefon_2 !== null &&
                                participant.telefon_2 !== participant.telefon_1
                                && (<label><br />{participant.telefon_2}</label>)
                            }
                        </td>
                        <td>
                            <label onClick={() => {
                                send_single_mail(participant.event_id, participant.id);
                            }} className={"solea_link"}>{__( 'Send email to', 'solea' )}</label>


                            { 'participation_group:addons' !== group_data.internal_group_name && null == participant.date_unregister && (
                                <span>
                                    <br />
                                    <label
                                        onClick={() => {
                                            solea_edit_participant(participant.id);
                                        }}
                                        className={"solea_link"}>
                                        {__( 'Edit', 'solea' )}
                                    </label>

                                    <br /><label onClick={() => {
                                        setSelectedParticipant(participant);
                                        setShowModalPayment(true);}
                                    } className={"solea_link"}>{__( 'Book partial payment', 'solea' )}</label>

                                    <br /><label onClick={() => {
                                    updatePartialPayment(
                                        setShowModalPayment,
                                        showToast,
                                        participant.id,
                                        participant.amount
                                    );}
                                    } className={"solea_link green"}>{__( 'Confirm payment', 'solea' )}</label>

                                    <br /><label onClick={() => {
                                        setSelectedParticipant(participant);
                                        setShowModalSignoff(true);}
                                    } className={"solea_link red"}>{__( 'Unregister', 'solea' )}</label>
                                </span>
                                )
                            }
                            {'participation_group:addons' !== group_data.internal_group_name && null != participant.date_unregister && (
                                <span>
                                    <br />
                                        <label onClick={() => {
                                            do_resignon(
                                                setShowModalSignoff,
                                                showToast,
                                                participant.id,
                                            );
                                        }
                                        } className={"solea_link green"}>{__( 'Re-Register', 'solea' )}</label>
                                </span>

                            )}
                        </td>
                    </tr>
                )))}
                </tbody>
            </table><br /><br />
            <label
                   className="button solea-button"
                   onClick={() => {
                       solea_send_group_mail(event_data.id, group_data.internal_group_name, event_data.addon_id);
                   }}>{__('Send mail to group', 'solea')}</label>


            <Modal title="Zahlung bearbeiten" isOpen={showModalPayment} onClose={() => setShowModalPayment(false)}>
                {selectedParticipant && (
                    <p>
                        Bitte gib hier den Betrag ein, der vom Teili insgesamt bereits gezahlt wurde:
                        <input
                            type="text"
                            className="solea_participant_modal_textbox"
                            name="amount_paid"
                            defaultValue={selectedParticipant.amount_to_pay_text}
                        />
                    </p>
                )}
                <button className="button solea-button" onClick={() => {
                    updatePartialPayment(setShowModalPayment, showToast, selectedParticipant.id, document.getElementsByName("amount_paid")[0].value);
                }
                }>{__('Confirm payment', 'solea')}</button>
                <button className="button solea-button cancel" onClick={() => setShowModalPayment(false)}>Schließen</button>
            </Modal>

            <Modal title="Teili abmelden" isOpen={showModalSignoff} onClose={() => setShowModalSignoff(false)}>
                <p>
                    Bitte gib das Datum ein, an dem die Abmeldeanforderung eingegangen ist:
                    <input name="signoff_date" className="solea_participant_modal_textbox" type="date" defaultValue={today} />
                </p>
                <button className="button solea-button cancel" onClick={() => {
                    do_signoff(
                        setShowModalSignoff,
                        showToast,
                        selectedParticipant.id,
                        document.getElementsByName("signoff_date")[0].value
                        );
                    }
                }>{__('Signoff', 'solea')}</button>
                <button className="button solea-button" onClick={() => setShowModalSignoff(false)}>{__('Cancel', 'solea')}</button>
            </Modal>
        </fieldset>
    );
}

export default SearchableParticipantList;


